import { type MCPServerInfo } from '../../types';

const CrowdstrikeServer: MCPServerInfo = {
  serverId: 'CROWDSTRIKE',
  name: 'CrowdStrike',
  slug: 'crowdstrike',
  description: 'Interact with CrowdStrike services over the CrowdStrike API.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'mcp/quay.io/crowdstrike/falcon-mcp:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['falcon_client_id', 'falcon_client_secret', 'falcon_base_url'],
    properties: {
      falcon_client_id: {
        type: 'string',
        description: 'CrowdStrike Falcon Client ID',
        sensitive: true
      },
      falcon_client_secret: {
        type: 'string',
        description: 'CrowdStrike Falcon Client Secret',
        sensitive: true
      },
      falcon_base_url: {
        type: 'string',
        description: 'Base URL for CrowdStrike API',
        sensitive: false
      }
    }
  }
};

export default CrowdstrikeServer;
